import { Component, OnInit } from '@angular/core';
import { ILecture } from 'src/app/views/pages/lectures/lecture.interface';
import migration from '../../../assets/data/migration.json';
import { CitiesService } from 'src/app/views/pages/lectures/cities/cities.service';
import { FirestoreRulesService } from 'src/app/core/firestore-rules/firestore-rules.service';
import { LanguagesEnum, LectureStatusEnum, LectureValuesData } from 'src/app/submit-lecture/lecture.values';
import { LecturesService } from 'src/app/views/pages/lectures/lectures.service';
import { UserService } from 'src/app/users/services/user.service';
import { COMPLETION_SCORE } from 'src/app/users/services/user-score.service';

const ALL_LECTURES_LAST_LECTURE_CHANGED_UPDATE_DATE = 'ALL_LECTURES_LAST_LECTURE_CHANGED_UPDATE_DATE';
export const MIN_CACHE_ROWS_2_TRIGGER_REMOTE_FETCHING = 2;
const USERS_LAST_USER_CHANGED_UPDATE_DATE = 'USERS_LAST_USER_CHANGED_UPDATE_DATE';

@Component({
  selector: 'modify-lectures',
  templateUrl: './modify-lectures.component.html',
  styleUrls: ['./modify-lectures.component.scss']
})

export class ModifyLecturesComponent implements OnInit {

  migratingArr: ILecture[];
  lecturesTransformArr: ILecture[];
  failedLecturesTransformArr: ILecture[];
  lecturesMigrationArr: ILecture[];
  failedLecturesMigrationArr: ILecture[];
  lectures: any;
  usersMeta: any;
  defaultUser: string;
  defaultCity: string;
  isFinished: boolean;

  constructor(private citiesService: CitiesService,
              private firestoreRulesService: FirestoreRulesService,
              private lecturesService: LecturesService,
              private userService: UserService) {
    this.migratingArr = migration;
    this.lecturesTransformArr = [];
    this.failedLecturesTransformArr = [];
    this.lecturesMigrationArr = [];
    this.failedLecturesMigrationArr = [];
  }

  ngOnInit(): void {
    this.lecturesTransformArr = [];
    this.getAllUsersMeta().then((res) => {
      this.usersMeta = res;
      this.modifyUsersMetaLogic();
    });
    // this.getAllLectures().then((res) => {
    //   this.lectures = res;
    //   this.start();
    // });
  }


  modifyLecturesLogic(): void {
    this.lectures.forEach(lecture => {
      const origLecture = {...lecture};
      const cityId = lecture.address.city;
      const cityInfo = this.citiesService.getCityById(cityId);
      lecture.address.subdistrict = cityInfo.subdistrict_id;
      this.lecturesService.updateLecture(lecture, origLecture);
    });
  }

  modifyUsersMetaLogic(): void {
    this.usersMeta.forEach(async meta => {
      // Get closed lectures by user
      const docs = await this.lecturesService.getLecturesByUserIdAndStatus(meta.metadata.docId, LectureStatusEnum.COMPLETE) as ILecture[];
      console.log(docs);
      let numOfCompleted = 0;
      let numOfParticipants = 0;
      docs.forEach(d => {
        if (d.feedback) {
          numOfCompleted += Number(d.feedback?.numberOfLectures);
          numOfParticipants += Number(d.feedback?.numberOfAttendees);
        }
      });

      if (!meta.progress) {
        meta.progress = {numOfCompleted: 0, numOfParticipants: 0, totalScore: 0};
      } else {
        if (meta.progress?.numberOfLectures) {
          meta.progress.numOfCompleted = meta.progress?.numberOfLectures;
          delete meta.progress?.numberOfLectures;
        }
      }

      meta.progress.numOfCompleted = numOfCompleted;
      meta.progress.numOfParticipants = numOfParticipants;
      meta.progress.totalScore = numOfCompleted * COMPLETION_SCORE;

      meta.docId = meta.metadata.docId;
      console.log(meta);
      this.userService.updateUserMetadataByDocId(meta.metadata.docId, meta);
    });
  }

  private addLectures(): void{
    this.lecturesTransformArr.forEach(async lecture => {

      // check for existing lecture by skyzid
      const skyzId = lecture.skyz_id;
      if (skyzId) {
        const docs = await this.lecturesService.getLecturesBySkyzID(skyzId) as ILecture[];
        if (!docs || docs.length === 0) {
          this.lecturesService.addLecture(lecture, true)
          .then(() => {
            this.lecturesMigrationArr.push(lecture);
            console.log('Lecture added ', lecture);
          })
          .catch((error) => {
            this.failedLecturesMigrationArr.push(lecture);
            console.error('Lecture failed to be added ', lecture);
            console.error(error);
          });
        } else {
          if (docs.length > 0) {
            docs.forEach((lect, i) => {
              if (i > 0) {
                this.lecturesService.deleteLecture(lect.metadata?.docId);
              } else {
                lecture.metadata = {docId: lect.metadata.docId};
                this.lecturesService.updateLecture(lecture)
                .then(() => {
                  this.lecturesMigrationArr.push(lecture);
                  console.log('Lecture updated ', lecture);
                })
                .catch((error) => {
                  this.failedLecturesMigrationArr.push(lecture);
                  console.error('Lecture failed to update ', lecture);
                  console.error(error);
                });
              }
            });
          }
        }
      }
    });
    this.isFinished = true;
  }

  private getStatus(status: string): LectureStatusEnum {
    const filtered: any[] = LectureValuesData.statuses.filter(st => {
      return (status.includes(st.nameEN) || status.includes(st.nameHE));
    });
    return filtered[0]?.id;
  }

  private getLanguage(lang: string): LanguagesEnum {
    const filtered: any[] = LectureValuesData.languages.filter(st => {
      return (lang.includes(st.nameEN) || lang.includes(st.nameHE));
    });
    return filtered[0].id;
  }

  getAllLectures(query?: any, forceCache = false): Promise<ILecture[]> {
    let lastChangedDocs;

    return  new Promise<ILecture[]>(async (resolve, reject) => {
        try {
          const lastLectureUpdateFromLocalStorage = localStorage.getItem(ALL_LECTURES_LAST_LECTURE_CHANGED_UPDATE_DATE);
          let docs = await this.firestoreRulesService.getAllLectures(true, query);
          // check if any lecture was updated since last cached
          if (docs && docs.length) {
            lastChangedDocs = await this.firestoreRulesService.getLastChangedLecture();
          }
          // if data was not fetched from cache or changes exist on fb lectures data then get data from fb
          if (this.isRemoteDataFetching(forceCache, docs, lastLectureUpdateFromLocalStorage, lastChangedDocs) ||
            docs?.length <= MIN_CACHE_ROWS_2_TRIGGER_REMOTE_FETCHING) {
            docs = await this.firestoreRulesService.getAllLectures(false, query);
            if (lastChangedDocs && lastChangedDocs.length > 0) {
              const changedDate = this.convertToDate(lastChangedDocs[0]?.updated_at);
              if (changedDate) {
                localStorage.setItem(ALL_LECTURES_LAST_LECTURE_CHANGED_UPDATE_DATE, changedDate.toString());
              }
            }
          }
          resolve(docs);
        } catch (error) {
          reject(error);
        }
      });
  }

  private isRemoteDataFetching = (forceCache: boolean, docs: any[], lastLectureUpdateFromLocalStorage: string,
                                  lastChangedDocs: ILecture[]): boolean => {
    let result;
    result  = !forceCache && (!docs || docs.length === 0 || !lastLectureUpdateFromLocalStorage || (lastChangedDocs && lastChangedDocs.length
              && this.isLastLectureUpdateGreaterThanLocalStotageDate(lastChangedDocs, lastLectureUpdateFromLocalStorage)));
    return result;
  }

  private isLastLectureUpdateGreaterThanLocalStotageDate(lastChangedDocs: ILecture[], lastLectureUpdateFromLocalStorage: string): boolean {
    const parsedDate = new Date(lastLectureUpdateFromLocalStorage);
    const now = Date.now();
    const twoHours = 2 * 60 * 60 * 1000;
    const isMoreThanTwoHours = (now - parsedDate.getTime()) > twoHours;
    const lastChangedDocDate = this.convertToDate(lastChangedDocs[0].updated_at);
    return (lastChangedDocDate > parsedDate) || (isMoreThanTwoHours);
  }

  private getAllUsersMeta(): Promise<unknown> {
    let lastChangedDocs;

    return new Promise<unknown>(async (resolve, reject) => {
      try {
        const lastUserUpdateDate = localStorage.getItem(USERS_LAST_USER_CHANGED_UPDATE_DATE);
        let docs = await this.firestoreRulesService.getAllUsersMeta(true);
        // check if any lecture was updated since last cached
        if (docs && docs.length) {
          lastChangedDocs = await this.firestoreRulesService.getLastChangedUser();
        }
        // if data was not fetched from cache or changes exist on fb lectures data then get data from fb
        if (!docs || docs.length === 0 || !lastUserUpdateDate || (lastChangedDocs && lastChangedDocs.length
            && this.checkIfLastLectureUpdateIsGreaterThenLocalDate(lastChangedDocs, lastUserUpdateDate))) {
          docs = await this.firestoreRulesService.getAssignedUsers(false);
          if (lastChangedDocs) {
            localStorage.setItem(USERS_LAST_USER_CHANGED_UPDATE_DATE,
                this.convertToDate(lastChangedDocs[0]?.updated_at).toString());
          }
        }
        resolve(docs);
      } catch (error) {
        reject(error);
      }
    });
  }

  private checkIfLastLectureUpdateIsGreaterThenLocalDate(lastChangedDocs: any[], lastUserUpdateDate: string): boolean {
    const parsedDate = new Date(lastUserUpdateDate);
    const lastChangedDocDate = this.convertToDate(lastChangedDocs[0].updated_at);
    return (lastChangedDocDate > parsedDate);
  }

  private normalize(str: string): string {
    if (!str || str.length === 0) {
      return str;
    }
    let norm = str.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
    norm = norm.replace(/\s/g, '');
    return norm.replace(/מתנדב/g, '');

  }

  private convertToDate(d: any): Date {
    if (!d) {
      return;
    }
    if (d instanceof Date) {
      return d;
    }

    const seconds = (d as any).seconds;
    const date = new Date(seconds * 1000);
    return date;
  }
}
